
import { Helpers } from '@bode-canada/core';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import { StyleSizeType, StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { formatDatetime, getTimezone } from '@/utils/date';

export default {
  name: 'RAEDisclaimer',
  components: {
    Typography,
  },
  props: {
    updatedAt: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      StyleSizeType,
      StyleColorSchemeType,
      TypographyType,
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
    lastUpdatedAt() {
      const UpdatedDateTime = formatDatetime({
        datetime: this.updatedAt,
        format: 'dddd, MMMM D, YYYY, h:mm:ss A',
      });
      const timeZone = getTimezone();

      return Helpers.StringHelper.joinStrings([
        UpdatedDateTime,
        timeZone,
      ], ' ');
    },
  },
};
